// extracted by mini-css-extract-plugin
export var wrapper = "Logo-module--wrapper--S3mKN";
export var blink = "Logo-module--blink--hiUcB";
export var isLab = "Logo-module--isLab--2IhL0";
export var lab = "Logo-module--lab--tOJSj";
export var showLab = "Logo-module--showLab--WQxmi";
export var dot = "Logo-module--dot--M0a+v";
export var charActive = "Logo-module--charActive--YO26n";
export var moveMe = "Logo-module--moveMe--9zJuR";
export var hideLab = "Logo-module--hideLab--cZRO1";